module.exports = __webpack_public_path__ + "img/22.6234a933.webp";